<!--
Item for displaying room booking information
Usage: <RoomBooking />
@author ab557z
-->
<template>
  <div class="bookingContainer">
    <Spinner ref="spinner" />
    <div class="bookingItems">
          <div class="roomHdr">{{ room }}</div>
      <div style="float:right;" v-if="bookingId">
          <button class="btn-ellipsis" type="button" aria-label="booking-actions" @click="prepDelete(bookingId)">
            <img title="cancel booking" alt="cancel booking" src="@/assets/redCross.svg"/>
          </button>
      </div>
      <div class="bookingDetail" v-if="date && !hideDate"><font-awesome-icon icon="calendar-alt" size="lg" class="bookingItemIcon"></font-awesome-icon>{{ date }}</div>
      <div v-if="startTime" class="bookingDetail">
      <span v-if="startTime" class="bookingTime"><font-awesome-icon :icon="['far', 'clock']" size="lg" class="bookingItemIcon">
      </font-awesome-icon>{{ startTime }} - {{ endTime }}
      </span>
      </div>
      <div class="bookingDetail" v-if="attendees && !hideAttendees">
      <font-awesome-icon icon="user" size="lg" class="bookingItemIcon">
      </font-awesome-icon>{{ attendees }} Attendee<span v-if="attendees>1 && !hideAttendees">s</span>
      </div>
      <div class="bookingDetail" v-if="capacity">
       <font-awesome-icon icon="info-circle" size="lg" class="bookingItemIcon"></font-awesome-icon>
       <span class="roomcapacity">Room capacity:</span> {{ capacity }}
      </div>
      <div class="bookingDetail" v-if="showNoFoodDrink">
        <img class="bookingItemIcon" src="@/assets/solid-burger-fries-slash.svg"/>No food or drink allowed
      </div>
      <div class="selectButton">
    <input type="button" @click=selectThis v-if="showSelect" class="bookingSelect" value="Select">
    </div>
      <div v-if="location" class="bookingDetail">
      <span v-if="location" class="seeLocationLink">
        <a class="see-location" :href="'#/map?buildingId='+ this.getBuildingId(location) + '&toId=' + location + '&toType=R'">See Location</a>
      </span>
      </div>
      <span v-if="bookingStatus == 3" class="cancelled">CANCELLED</span>
      <span v-if="bookingStatus == 1" class="provisional">PROVISIONAL</span>
    </div>
    <!-- NewModalPopup hideTitleBar="true" :id="'bookingActions'+bookingId" title="Booking Actions">
      <button type="button" data-dismiss="modal" :data-target="'#confirm'+bookingId + 'Modal'" data-toggle="modal" class="btn"><font-awesome-icon icon="times-circle" /><span class="cancel-booking">Cancel Booking</span></button>
    </NewModalPopup -->
    <NewModalPopup v-if="showDeleteConfirmPopup" hideTitleBar="true" :id="'confirm'+bookingId" title="Confirm">
     <div class="confHdr">Cancel booking</div>
     <div class="confText">Are you sure you want to cancel your room booking?</div>
      <table class="cancel-rb" role="group" aria-label="cancellation buttons">
        <tr>
          <td>
            <button class="btn-choice" data-dismiss="modal" v-on:click="deleteBooking">Yes, cancel booking</button>
          </td>
        </tr>
        <tr>
          <td>
            <button class="btn-choice-cancel" @click="showDeleteConfirmPopup = false">No</button>
          </td>
        </tr>
      </table>
     </NewModalPopup>
  </div>

</template>

<script>
// NOTE: if the booking actions menu now has more than one action,
//       switch btn with aria label 'booking actions' above
//       from "'#confirm'+bookingId+'Modal'" back to "'#bookingActions'+bookingId+'Modal'"
import StringUtil from '@/mixins/StringUtil.js'
import Spinner from '@/components/Spinner.vue'
// import ItemPopup from '@/components/ItemPopup.vue'
import NewModalPopup from '@/components/NewModalPopup.vue'
import axios from 'axios'
import { store } from '@/components/reactiveStore.js'

export default {
  name: 'RoomDisplay',
  components: {
    NewModalPopup,
    Spinner,
},
  props: ['changeCallback',
    'bookingId', 'bookingStatus',
    'room', 'date', 'startTime', 'endTime', 'capacity', 'location', 'attendees',
    'showSelect', 'hideDate', 'hideAttendees', 'showNoFoodDrink'],
  mixins: [StringUtil],
  data () {
    return {
      showDeleteConfirmPopup: false,
      deleteBookingId: 0
    }
  },
  methods: {
    prepDelete (id) {
      this.showDeleteConfirmPopup = true
      this.deleteBookingId = id
    },
    createData () {
    },
    submitForm () {
      // in vue 3 i opted to stuff these in a reactive store
      // rather than in the path...
      store.put({
        bookingDate: this.date,
        startTime: this.startTime,
        endTime: this.endTime,
        attendees: this.attendees,
        location: this.room,
        capacity: this.capacity,
        roomid: this.location
      })

      this.$router.push({
        name: 'bookingSummary'
      })
    },
    selectThis () {
      // this.createData()
      this.submitForm()
    },
    confirmDelete () {
      // document.getElementById('confirm' + b + 'Modal').modal('show')
      alert('confirm')
    },
    deleteBooking () {
      this.$refs.spinner.spin()
      axios.delete('/timetable/booking', {
        params: {
          bookingId: this.bookingId
        }
      })
        .then(() => {
          // $cookies.set('noTimetable', response.data.noTimetable, 0)
          this.ajaxDone('cancelBookingModal')
          this.cancelBookingDisabled = false
        }).catch(error => {
          console.log('ERROR')
          console.log(error)
        })
    },
    ajaxDone () {
      console.log('change was made; firing callback')
      this.changeCallback() // tell the parent to update itself
      this.$refs.spinner.stop()
      // document.getElementById('#' + modalId).modal('hide')
    }
  }
}
</script>

<style scoped>
.confHdr {
  color: #003865;
  font-size: 20px;
  font-weight: 700;
}
.confText {
  font-size: 18px;
  font-weight: 400;
  color: #4F5961;
}
div.selectButton {
  margin-top: 15px;
  margin-bottom: 8px;
  width: 100%;

  text-align: center;
}
span.seeLocationLink {
  display: block;
  width: 100%;
  text-align: center;
}
.roomHdr {
  color:#003865;
  font-weight:bold;
  font-size:18px;
  margin-top:15px;
  margin-bottom:0px;
  height: auto;
}
.bookingSelect {
  background: #003865;
  border-radius: 12px;
  border:1px solid #003865;
  padding-top:6px;
  padding-bottom:4px;
  margin-left:-24px !important;
  width: 326px;
  height: 52px;
  text-align:center;
  padding-left:8px;
  padding-right:8px;
  color:#ffffff;
  font-weight:700;
}

.bookingTime {
  margin-bottom:16px;
}

.bookingItems {
  margin-top:15px;
  margin-left:16px;
  /* margin-right:16px; */
}
.bookingContainer {
  position:relative;
  border:1px solid #E0E0E0;
  border-left:0px;
  border-right:0px;
  padding-bottom:26px;
}
.bookingItemIcon {
  margin-bottom:0.5px;
  margin-right:14px;
  margin-left:1px;
  color:#003865;
  width: 25px;
}

.cancelled {
  opacity: 0.5;
}

.provisional {
  padding: 3px;
  font-size:small;
  background-color: #FE416D;
  border: 1px solid #DE0663 !important;
  color: #ffffff;
  border-radius: 6px !important;
}

.roomcapacity {
  color: #4F5961;
}

.btn-ellipsis {
    background: #fff;
    border: white;
}
.btn-primary-uofg {
    background-color: #951272;
}
.cancel-booking {
  padding-left: 20px;
}

table.cancel-rb {
  width: 100%;
  padding: 10px;
  margin-top: 12px;
}

table.cancel-rb tr td {
  padding: 5px;
}
a.location {
  color: #951272;
}

.btn-choice-cancel {
  border: 2px solid #003865;
  background: #fff;
  box-sizing: border-box;
  color: #003865;
  border-radius: 12px;
  font-weight:bold;
    height:51px;
  width:100%;
  text-align:center;

}

.btn-choice {
  background: #003865;
  border-radius: 12px;
  border:1px solid #003865;
  padding-top:6px;
  padding-bottom:4px;
  height:51px;
  width:100%;
  text-align:center;
  padding-left:8px;
  padding-right:8px;
  color:#ffffff;
  font-weight:bold;
}

.roomHdr {
  line-height: 30px;
}

.bookingDetailCapacity {
  color: blue;
}

.bookingDetail {
  line-height: 35px;
  color: #4F5961;
  font-size: 18px;
}

a.see-location {
  color:#003865;
  text-decoration:none;
  font-weight: 700;
}
</style>
